module.exports = __webpack_public_path__ + "static/media/Edberghof01.ef32810d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Edberghof01.jpg
// module id = 361
// module chunks = 0